module.exports = __webpack_public_path__ + "static/media/background.6c79334d.jpg";